<div class="wrap">
    <div class="container">
        <app-header></app-header>
    </div>
    <div class="aviso-container flex flex-col space-y-10 pt-36">

        <div class="max-w-4xl mx-auto">
            <h1 class="text-xl font-bold text-customPurple-600 mb-4 text-center">
                Aviso de Privacidad
            </h1>
            <h2 class="text-lg font-bold text-customPurple-600 mb-8 text-center">
                Para solicitudes
            </h2>

            <div class="space-y-6 text-customBlack-500">
                <p class="text-justify">
                    Con base en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares
                    publicada en el Diario Oficial de la Federación el día 5 de julio de 2010, TEU TECHNOLOGIES
                    S.A.P.I. DE C.V., con domicilio en Lago Alberto No. 369, interior 719, colonia Anáhuac I
                    Sección, alcaldía Miguel Hidalgo, C.P. 11320, Ciudad de México, México, se compromete al
                    tratamiento legítimo, controlado e informado de los datos recabados a Usted como Titular de los
                    mismos, de los datos de las personas físicas que comparezcan en los instrumentos jurídicos a que
                    se refiere el numeral (ii) siguiente y de los datos de su (s) representante (s) legal (es), si
                    fuera el caso, comprometiéndose a que dichos datos personales serán tratados bajo las más
                    estrictas medidas de seguridad que garanticen su confidencialidad.
                </p>

                <p class="text-justify">
                    TEU TECHNOLOGIES S.A.P.I. DE C.V., manifiesta que la finalidad del tratamiento de los datos
                    personales serán para proveer los servicios y productos requeridos por el solicitante, los
                    cuales pueden ser entre otros (i) Analizar la capacidad crediticia del Titular y /o enunciativa
                    más no limitativamente de las personas físicas que comparezcan como sus garantes, depositarios,
                    avales, etc., a fin de celebrar los instrumentos jurídicos mencionados en el siguiente literal
                    ii) Incorporarlos en los instrumentos jurídicos que se requieran para la formalización del
                    financiamiento que otorgue ya sea a través de contratos de arrendamiento puro, financiero y /o
                    crédito simple o cualesquier otro, así como todos los instrumentos jurídicos y títulos de
                    crédito, accesorios al financiamiento iii) Informar sobre cambios o nuevos productos o servicios
                    que estén relacionados con los contratados o adquiridos previamente.
                </p>

                <p class="text-justify">
                    TEU TECHNOLOGIES S.A.P.I. DE C.V., se reserva el derecho de efectuar en cualquier momento
                    modificaciones o actualizaciones al presente aviso de privacidad, para la atención de novedades
                    legislativas, políticas internas o nuevos requerimientos para la prestación u ofrecimiento de
                    nuestros servicios o productos. Estas modificaciones estarán disponibles al público a través de
                    los siguientes medios: (i) anuncios visibles en nuestros establecimientos (ii) en nuestra página
                    de Internet (sección aviso de privacidad); (iii) o se harán llegar al último correo electrónico
                    proporcionado por el solicitante.
                </p>

                <p class="text-justify">
                    El que solicitante manifiesta bajo protesta de decir verdad que es el titular de los documentos
                    proporcionados y datos asentados en la presente solicitud, ya sea como persona física o como
                    representante legal del titular si este último es persona moral y que es responsable para todos
                    los efectos legales a que haya lugar, de la autenticidad de los mismos.
                </p>

                <p class="text-justify">
                    Se hace del conocimiento del solicitante que debido a la naturaleza de los servicios
                    proporcionados por TEU TECHNOLOGIES S.A.P.I. DE C.V., y de conformidad a las disposiciones
                    legales que le resultan aplicables, ésta conservará sus datos personales por un periodo mínimo
                    de diez años, pudiendo ser actualizados de manera periódica a solicitud de TEU TECHNOLOGIES
                    S.A.P.I. DE C.V.
                </p>

                <p class="text-justify">
                    Si el solicitante considera que su derecho de protección de datos personales ha sido lesionado
                    por alguna conducta, actuación o respuesta o presume que en el tratamiento de sus datos
                    personales existe alguna violación a las disposiciones previstas en la Ley Federal de Protección
                    de Datos Personales en Posesión de los Particulares, podrá interponer la queja o denuncia
                    correspondiente ante el IFAI, para mayor información visite <a href="http://www.ifai.org.mx"
                        class="text-customBlue-600 hover-underline" target="_blank"
                        rel="noopener noreferrer">www.ifai.org.mx</a>
                </p>
                <br /><br /><br />
            </div>
        </div>
    </div>
    <app-footer [colorClass]="footerColorClass"></app-footer>
</div>
